import React from 'react'
import Header from '../../components/Header'
import { Toast, Modal } from 'antd-mobile';
import './index.less'
import { getAudioMission, addPraise, audioReport } from '../../api/sound'
import { isWeChat, getQueryString, jumpApp, getNickName, timeFormat, initParameter, checkLogin } from '../../utils/utils'
import ShareShadeLayer from '../../components/Sound/shareShadeLayer'
import Share from '../../components/Sound/share'
import { advert } from '../../api/count'
import { getShareContent } from '../../api/share'
import Cookies from 'js-cookie'
import DocumentTitle from 'react-document-title'
import { global } from '../../config/index'

export default class SoundIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: isWeChat(),
      downloadAppModal: false,
      feedbackModal: false,
      soundRecordModal: false,
      data: [],
      paused: true,
      audio1Paused: true,
      currentAudio: {},
      feedbackItem: {},
      soundRecordItem: {},
      sign: '',
      wxShareVisible: false,
      wxShareItem: {},
      shareContent: {}
    }
  }

  componentWillMount = () => {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (!sign && this.state.client == 1) {
      let url = global.wxAuthorizeBaseUrl + '?op=wxWebAudioLogin&from_sso_id=' + getQueryString('from_sso_id') + '&invite_type='
        + getQueryString('invite_type') + '&picture_id=' + getQueryString('picture_id') + '&channel_id=' + getQueryString('channel_id')
        + '&reply_id=' + getQueryString('reply_id') + '&audio_id=' + getQueryString('audio_id') + '&base_url=' + global.href + 'lg/sound/index'
      window.location.href = url;
    } else {
      this.setState({
        sign: true
      })
    }
  }

  componentDidMount() {
    window.announcerModal = this.announcerModal
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (sign) {
      //if (global.debugProcess || checkLogin()) {
      this.requestList()
      this.initPlay()
      advert({
        operate: 'audiomission',
        label: 'open_audio_page',
      }).then((res) => { })
    }
  }

  requestList = () => {
    let reply_id = getQueryString('reply_id') ? getQueryString('reply_id') : 0
    let audio_id = getQueryString('audio_id') ? getQueryString('audio_id') : 0
    let from_sso_id = getQueryString('from_sso_id') ? getQueryString('from_sso_id') : 0
    getAudioMission({ audio_id: audio_id, reply_id: reply_id, from_sso_id: from_sso_id }).then((res) => {
      this.setState({
        data: res
      }, () => {
        if (this.state.client == 1) {
          this.handleGetShareContent({})
        }
      })
    })
  }

  handleGetShareContent = () => {
    getShareContent({ type: 5 }).then((res) => {
      this.setState({
        shareContent: res
      }, () => {
        this.handleWxShaer({})
      })
    })
  }

  handleWxShaer = (item) => {
    let audio_mission = this.state.data.audio_mission
    let res = this.state.shareContent
    let wxShareVisible = true
    let url = res.url
    if (res.url.indexOf('?') > 0) {
      url += '&'
    } else {
      url += '?'
    }
    url += 'invite_type=' + res.invite_type + '&picture_id=' + res.picture_id + '&channel_id=' + res.channel_id
      + '&audio_id=' + audio_mission.id
    if (item.id) {
      url += '&reply_id=' + item.id + '&from_sso_id=' + item.sso_id
      advert({
        operate: 'audiomission',
        label: 'share_friend_5',
      }).then((res) => { })
    } else {
      wxShareVisible = false
      url += '&from_sso_id=' + Cookies.get('sso_id')
    }
    this.setState({
      wxShareVisible: wxShareVisible,
      wxShareItem: {
        title: res.name,
        link: url,
        desc: res.detail,
        imgUrl: res.image,
      }
    })
  }


  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  }

  initPlay = () => {
    let audio = this.refs.audio
    let audio1 = this.refs.audio1
    let _this = this

    //开始播放：
    audio.onplay = function () {
      _this.setState({
        paused: false
      })
    }

    //暂停播放：
    audio.onpause = function () {
      _this.setState({
        paused: true
      })
    }

    //开始播放：
    audio1.onplay = function () {
      _this.setState({
        audio1Paused: false
      })
    }

    //暂停播放：
    audio1.onpause = function () {
      _this.setState({
        audio1Paused: true
      })
    }
  }

  // 分享
  handlerShare = (item, type) => {
    advert({
      operate: 'audiomission',
      label: 'share_friend_5_all',
    }).then((res) => { })
    if (type === 1) {
      this.setState({
        soundRecordModal: false
      })
    }
    if (this.state.client == 1) {
      this.handleWxShaer(item)
    } else {
      jumpApp({ opentype: 'invite_share', openvar: '', type: 5, share_type: "h5", reply_id: item.id, audio_id: item.audio_id, from_sso_id: item.sso_id })
    }
  }

  //点赞
  handleAddPraise = (item) => {
    if (item.is_praise) {
      Toast.info('你已经点过赞了', 1.5)
      return;
    }
    addPraise({ reply_id: item.id, audio_id: item.audio_id }).then((res) => {
      Toast.info('点赞成功')
      this.requestList()
    })
  }

  //我来回答
  handleAnswer = () => {
    if (this.state.client == 1) {
      this.setState({
        downloadAppModal: true
      })
    } else {
      let has_audio = (this.state.data && this.state.data.my_reply && this.state.data.my_reply.id > 0) ? 1 : 0
      jumpApp({ opentype: 'record', openvar: '', audio_id: this.state.data.audio_mission.id, has_audio: has_audio })
    }
  }

  //录音成功后弹窗  客户端调取H5
  announcerModal = (image, id, audio_id) => {
    this.requestList()
    if (this.state.data && (!this.state.data.my_reply || !this.state.data.my_reply.id)) {
      this.setState({
        soundRecordModal: true,
        soundRecordItem: {
          image: image,
          id: id,
          audio_id: audio_id,
          sso_id: 0
        }
      })
    }
  }

  //举报
  handleFeedback = (item) => {
    this.setState({
      feedbackModal: true,
      feedbackItem: item
    })
  }

  //举报接口
  handleAudioReport = () => {
    let item = this.state.feedbackItem
    let _this = this
    audioReport({ reply_id: item.id, audio_id: item.audio_id }).then((res) => {
      _this.setState({
        feedbackModal: false
      })
      Toast.info('举报成功')
    })
  }

  audioPlay = () => {
    let audio = this.refs.audio
    let audio1 = this.refs.audio1
    audio1.pause();
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  }

  audio1Play = (item, type) => {
    let audio = this.refs.audio
    let audio1 = this.refs.audio1
    audio.pause();
    if (!this.state.currentAudio.id || this.state.currentAudio.id != item.id || this.state.currentAudio.audioType != type) {
      audio1.src = item.mp3
      item.audioType = type ? type : 0
      this.setState({
        currentAudio: item
      })
    }

    if (audio1.paused) {
      audio1.play();
    } else {
      audio1.pause();
    }
  }

  //查看更多
  viewMore = (type) => {
    let title = '最新回答'
    if (type == 1) {
      title = '精彩回答'
    }
    let audio_id = this.state.data.audio_mission.id
    this.props.history.push("/lg/sound/answerList?title=" + title + '&type=' + type + '&audio_id=' + audio_id)
  }

  //人气榜单
  goPopularityList = () => {
    let audio_id = this.state.data.audio_mission.id
    this.props.history.push("/lg/sound/popularityList?audio_id=" + audio_id)
  }

  //下载登录
  handleDownload = () => {
    if (this.state.client == 1) {
      window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.saker.app.huhu&ckey=CK1404130488352'
    }
  }

  goOldAudioMission = (item) => {
    // this.props.history.push("/lg/sound/index?audio_id=" + item.id)
    window.location.href = global.href + "lg/sound/index?audio_id=" + item.id
  }

  //广告链接
  goNoticeLink = () => {
    let audio_entrance = this.state.data.audio_entrance
    window.location.href = audio_entrance.openvar
  }

  render() {
    let { client, paused, data, currentAudio, audio1Paused, soundRecordItem, sign, wxShareVisible, wxShareItem } = this.state
    return (
      <DocumentTitle title="声音乐园" >
        {
          client != 1 || sign ?
            <div className="sound-index-wrap">
              <Header name="声音乐园" />
              {
                client == 1 ?
                  <div className="huhuapp-ad">
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div className="logo">
                        <img src={require('../../images/share/open_app_logo.png')} alt="" />
                      </div>
                      <div className="info">
                        <h3 className="keynote">打开呼呼收音机</h3>
                        <p className="text">让孩子有个多彩的童年</p>
                      </div>
                    </div>
                    <div onClick={this.handleDownload} className="album-detail-ad-button">
                      立即打开
            </div>
                  </div> : ''
              }

              <article className="sound-index-container">
                <div className="header-container">
                  {
                    data && data.audio_mission ?
                      <div className="banner" style={{ backgroundImage: `url(${data.audio_mission.image})` }}>
                        <img className="play-btn" onClick={this.audioPlay}
                          src={paused ? require('../../images/sound/play_btn.png') : require('../../images/sound/pause_btn.png')} alt="" />
                      </div>
                      : ''
                  }

                  <div className="answer-btn" onClick={this.handleAnswer}>
                    <img src={require('../../images/sound/to_answer_btn.gif')} alt="" />
                  </div>
                </div>

                {
                  data && data.friend_reply && data.friend_reply.id > 0 ?
                    <div className="friend-answer-container">
                      <div className="friend-answer__header">
                        <h3 className="title"><span className="text">{getNickName(data.friend_reply.nickname)}</span>的回答</h3>
                        {
                          data && data.friend_reply && data.friend_reply.id > 0 ?
                            <div className="broadcast-name">
                              <img src={data.friend_reply.medal.image} alt="" />
                            </div>
                            : ''
                        }
                      </div>
                      {
                        data && data.friend_reply && data.friend_reply.id > 0 ?
                          <div className="friend-answer__content">
                            <div className="friend-answer__body">
                              <div className="left">
                                <div className="avatar">
                                  <img src={data.friend_reply.icon} alt="" />
                                </div>
                              </div>
                              <div className="right">
                                <div className="info">
                                  <span className="nickname">{getNickName(data.friend_reply.nickname)}</span>
                                  <span className="time">{timeFormat(data.friend_reply.modify_date, 16, '.')}</span>
                                </div>
                                <div className="voice" onClick={() => { this.audio1Play(data.friend_reply, 5) }}>
                                  {data.friend_reply.second}s
                        <img className="voice_wifi" src={
                                    currentAudio.id == data.friend_reply.id && currentAudio.audioType == 1 && !audio1Paused ?
                                      require('../../images/sound/wifi_active.gif') :
                                      require('../../images/sound/wifi.png')} alt="" />
                                </div>
                              </div>
                            </div>
                            <div className="friend-answer__footer">
                              <div className="left" onClick={() => { this.handleAddPraise(data.friend_reply) }}>
                                <img src={require('../../images/sound/big_red_flower_btn.png')} alt="" />
                                <span className="text">{data.friend_reply.praise_count}</span>
                              </div>
                              <div className="right" onClick={() => { this.handlerShare(data.friend_reply) }}>
                                <img src={require('../../images/sound/share_btn.png')} alt="" />
                                <span className="text">分享</span>
                              </div>
                            </div>
                          </div>
                          :
                          <div className="friend-answer__no-content">
                          </div>
                      }
                    </div>
                    : ''
                }

                <div className="my-answer-container">
                  <div className="my-answer__header">
                    <h3 className="title">我的回答</h3>
                    {
                      data && data.my_reply && data.my_reply.id > 0 ?
                        <div className="broadcast-name">
                          <img src={data.my_reply.medal.image} alt="" />
                        </div>
                        : ''
                    }
                  </div>

                  {
                    data && data.my_reply && data.my_reply.id > 0 ?
                      <div className="my-answer__content">
                        <div className="my-answer__body">
                          <div className="left">
                            <div className="avatar">
                              <img src={data.my_reply.icon} alt="" />
                            </div>
                          </div>
                          <div className="right">
                            <div className="info">
                              <span className="nickname">{getNickName(data.my_reply.nickname)}</span>
                              <span className="time">{timeFormat(data.my_reply.modify_date, 16, '.')}</span>
                            </div>
                            <div className="voice" onClick={() => { this.audio1Play(data.my_reply, 1) }}>
                              {data.my_reply.second}s
                        <img className="voice_wifi" src={
                                currentAudio.id == data.my_reply.id && currentAudio.audioType == 1 && !audio1Paused ?
                                  require('../../images/sound/wifi_active.gif') :
                                  require('../../images/sound/wifi.png')} alt="" />
                            </div>
                          </div>
                        </div>
                        <div className="my-answer__footer">
                          <div className="left" onClick={() => { this.handleAddPraise(data.my_reply) }}>
                            <img src={require('../../images/sound/big_red_flower_btn.png')} alt="" />
                            <span className="text">{data.my_reply.praise_count}</span>
                          </div>
                          <div className="right" onClick={() => { this.handlerShare(data.my_reply) }}>
                            <img src={require('../../images/sound/share_btn.png')} alt="" />
                            <span className="text">分享</span>
                          </div>
                        </div>
                      </div>
                      :
                      <div className="my-answer__no-content"></div>
                  }

                  <div className="my-answer__popularity-list" onClick={this.goPopularityList}>
                  </div>

                  {
                    data && data.audio_entrance && data.audio_entrance.id > 0 && data.audio_entrance.status == 1 ?
                      <div className="my-answer__notice" onClick={this.goNoticeLink}>
                        <img src={data.audio_entrance.image} alt="" />
                      </div>
                      : ''
                  }
                </div>

                {/* 精彩回答 */}
                <div className="wonderful-answer-container">
                  <div className="wonderful-answer__header">
                    <h3 className="title">精彩回答</h3>
                    {
                      data && data.splendid_reply && data.splendid_reply.length > 0 ?
                        <div className="more" onClick={() => { this.viewMore(1) }}>
                          更多回答
                    <img src={require('../../images/sound/arrow_right_btn.png')} alt="" />
                        </div>
                        : ''
                    }

                  </div>
                  {
                    data && data.splendid_reply && data.splendid_reply.length > 0 ?
                      <div className="wonderful-answer__list">
                        {
                          data.splendid_reply.map((item, i) => (
                            <div className="item" key={i}>
                              <div className="avatar" onClick={() => { this.handleFeedback(item) }}>
                                <img src={item.icon} alt="" />
                              </div>
                              <div className="info">
                                <div className="row">
                                  <span className="nickname">{getNickName(item.nickname)}</span>
                                  <span className="time">{timeFormat(item.modify_date, 16, '.')}</span>
                                </div>
                                <div className="row" style={{ marginTop: '3px' }}>
                                  <div className="voice" onClick={() => { this.audio1Play(item, 2) }}>
                                    {item.second}s
                              <img className="voice_wifi"
                                      src={currentAudio.id == item.id && currentAudio.audioType == 2 && !audio1Paused ?
                                        require('../../images/sound/wifi_active.gif')
                                        : require('../../images/sound/wifi.png')} alt="" />
                                  </div>
                                  <div className="zan-btn" onClick={() => { this.handleAddPraise(item) }}>
                                    <img src={require(`../../images/sound/${item.is_praise ? 'mini_flower_btn_active' : 'mini_flower_btn'}.png`)} alt="" />
                                    <span className="zan-num">{item.praise_count}</span>
                                  </div>
                                  <span className="share-btn" onClick={() => { this.handlerShare(item) }}></span>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                      :
                      <div className="no-content">
                      </div>
                  }
                </div>

                <div className="recent-answer-container">
                  <div className="recent-answer__header">
                    <h3 className="title">最新回答</h3>
                    {
                      data && data.newest_reply && data.newest_reply.length > 0 ?
                        <div className="more" onClick={() => { this.viewMore(2) }}>
                          更多回答<img src={require('../../images/sound/arrow_right_btn.png')} alt="" />
                        </div>
                        : ''
                    }
                  </div>
                  {
                    data && data.newest_reply && data.newest_reply.length > 0 ?
                      <div className="recent-answer__list">
                        {
                          data.newest_reply.map((item, i) => (
                            <div className="item" key={i}>
                              <div className="avatar" onClick={() => { this.handleFeedback(item) }}>
                                <img src={item.icon} alt="" />
                              </div>
                              <div className="info">
                                <div className="row">
                                  <span className="nickname">{getNickName(item.nickname)}</span>
                                  <span className="time">{timeFormat(item.modify_date, 16, '.')}</span>
                                </div>
                                <div className="row" style={{ marginTop: '3px' }}>
                                  <div className="voice" onClick={() => { this.audio1Play(item, 3) }}>
                                    {item.second}s
                          <img className="voice_wifi" src={
                                      currentAudio.id == item.id && currentAudio.audioType == 3 && !audio1Paused ?
                                        require('../../images/sound/wifi_active.gif')
                                        : require('../../images/sound/wifi.png')} alt="" />
                                  </div>
                                  <div className="zan-btn" onClick={() => { this.handleAddPraise(item) }}>
                                    <img src={require(`../../images/sound/${item.is_praise ? 'mini_flower_btn_active' : 'mini_flower_btn'}.png`)} alt="" />
                                    <span className="zan-num">{item.praise_count}</span>
                                  </div>
                                  <span className="share-btn" onClick={() => { this.handlerShare(item) }}></span>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                      :
                      <div className="no-content">
                      </div>
                  }
                </div>

                {/* 往期主题 */}
                {
                  data && data.old_audio_mission && data.old_audio_mission.length > 0 ?
                    <div className="past-period-theme-container">
                      <div className="past-period-theme__header">
                        <h3 className="title">往期主题</h3>
                        {/* <div className="more">
                  更多主题<img src={require('../../images/sound/arrow_right_btn.png')} alt="" />
                </div> */}
                      </div>
                      <div className="past-period-theme__list">
                        {
                          data.old_audio_mission.map((item, i) => (
                            <div className="item" key={i} onClick={() => { this.goOldAudioMission(item) }}>
                              <img src={item.image_ex} alt="" />
                            </div>
                          ))
                        }
                      </div>
                    </div>
                    : ''
                }


                <div style={{ height: '2rem' }}></div>

                <audio ref="audio" src={data && data.audio_mission ? data.audio_mission.mp3 : ''} style={{ display: 'none' }}>
                  Your browser does not support the audio element.
            </audio>
                <audio ref="audio1" src="" style={{ display: 'none' }}>
                  Your browser does not support the audio element.
            </audio>
              </article>

              <Modal
                visible={this.state.downloadAppModal}
                className="sound-index-modal"
                transparent
                maskClosable={true}
                onClose={this.onClose('downloadAppModal')}
              >
                <div className="modal-container1">
                  <div className="content">
                    <div className="title">打开呼呼收音机APP参与回答</div>
                    <div className="button" onClick={this.handleDownload}>
                      立即打开
                  </div>
                  </div>
                </div>
              </Modal>

              <Modal
                visible={this.state.feedbackModal}
                className="sound-index-modal"
                transparent
                maskClosable={true}
                onClose={this.onClose('feedbackModal')}
              >
                <div className="modal-container2">
                  <div className="content">
                    <div className="title">您是否要举报这条回答</div>
                    <div className="button">
                      <div className="left" onClick={this.onClose('feedbackModal')}>取消</div>
                      <div className="right" onClick={this.handleAudioReport}>确定</div>
                    </div>
                  </div>
                </div>
              </Modal>

              <Modal
                visible={this.state.soundRecordModal}
                className="sound-index-modal"
                transparent
                maskClosable={true}
                onClose={this.onClose('soundRecordModal')}
              >
                <div className="modal-container3">
                  <div className="content" style={{ backgroundImage: `url(${soundRecordItem.image})` }}>
                    <div className="button">
                      <div className="left" onClick={this.onClose('soundRecordModal')}>取消</div>
                      <div className="right" onClick={() => { this.handlerShare(soundRecordItem, 1); }}>立即分享</div>
                    </div>
                  </div>
                </div>
              </Modal>
              {
                client == 1 ? <ShareShadeLayer wxShareVisible={wxShareVisible} onShow={this.onClose('wxShareVisible')} />
                  : ''
              }

              {
                client == 1 && wxShareItem.title ?
                  <Share obj={wxShareItem} onClose={this.onClose('wxShareVisible')} /> : ''
              }

            </div>
            : ''
        }
      </DocumentTitle>
    );
  }
}